import { Suspense, type ReactNode } from "react";
import { Navigate } from "react-router-dom";

export type RouteDef = { path: string; element: ReactNode };

export const PageFallback = () => (
  <div className="min-h-[60vh] flex items-center justify-center">
    <div className="w-10 h-10 rounded-full border-2 border-accent/30 border-t-accent animate-spin" />
  </div>
);

/** Wrap a lazy page in Suspense with a lightweight loading state. */
export const L = ({ children }: { children: ReactNode }) => (
  <Suspense fallback={<PageFallback />}>{children}</Suspense>
);

export { Navigate };
